import { createSignal } from "@react-rxjs/utils"

type InstrumentSymbol = string

export const [confirmClosePosition$, confirmClosePosition] =
  createSignal<InstrumentSymbol>()
